export const BRAND_NAVY = '#212443';
export const BRAND_BLUE = '#0079CC';
export const BRAND_GREEN = '#1F8466';
export const BRAND_RED = '#E81212';
export const BRAND_YELLOW = '#F6DC9F';
export const BRAND_PURPLE = '#6C0E7C';
export const BRAND_BROWN = '#CC996C';
